import { Component, OnInit } from '@angular/core';
import { UtilitieService } from 'src/app/services/utils/utilities.service';

@Component({
  selector: 'privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.css']
})
export class PrivacyPolicyComponent implements OnInit{

  constructor(private utilService: UtilitieService){
    this.utilService.updateLoading(false);
  }
  ngOnInit(): void {
    
  }

}
